import {patchState, Prettify, signalStoreFeature, withMethods} from '@ngrx/signals';
import {InnerSignalStore} from '@ngrx/signals/src/signal-store-models';

import {currentActionNames} from './shared/devtools.info';
import {getSignalStoreMetaData, isWithMetaDataFeature} from './shared/with-metadata-feature.types';

type WholeObject<T> = {
	[K in keyof T]: T[K];
};

type DeepPartial<T> = {
	[K in keyof T]?: DeepPartial<T[K]>;
};

function deepAssign<T extends WholeObject<T>>(target: T, patches: DeepPartial<T>) {
	for (const key in patches) {
		if (patches.hasOwnProperty(key)) {
			const patch = patches[key];
			if (typeof patch === 'object' && patch !== null) {
				deepAssign(target[key], patch);
			} else {
				Object.assign(target, {[key]: patch});
			}
		}
	}
	return target;
}

/**
 * Patches the state of the store with the provided patches. (allows to provide a custom action name to view in Redux DevTools)
 * @param store - The store to patch the state of.
 * @param patches - The patches to apply to the state.
 * @param action - The action name to view in Redux DevTools.
 * @param patchFn - The function to use to patch the state.
 * @public
 */
export function patchStateWithAction(store: StoreState, patches: Prettify<DeepPartial<StoreState>>, action: string, patchFn: typeof patchState = patchState) {
	if (isWithMetaDataFeature(store)) {
		action = `[${getSignalStoreMetaData(store).StoreName}] ${action}`;
	}
	currentActionNames.value.add(action);
	patchState(store, patches);
}

// type WithUpdateStateOutput = EmptyFeatureResult & {
// 	methods: {
// 		/** Updates the state of the store with the provided patches. */
// 		updateState(patches: DeepPartial<SignalStoreFeatureResult['state']>, action: string): void;
// 	};
// };

// type WithUpdateStateOutput<SStore extends SignalStoreFeatureResult = SignalStoreFeatureResult> = EmptyFeatureResult & {
// 	methods: {
// 		/** Updates the state of the store with the provided patches. */
// 		updateState(patches: DeepPartial<SStore['state']>, action: string): void;
// 	};
// };

/**
 * Adds the ability to update the state of the store with patches as a feature to a ngrx `SignalStore`.
 * @returns The SignalStore feature with the ability to update the state of the store with patches applied.
 */
export function withUpdateState() {
	return signalStoreFeature(
		withMethods((store: InnerSignalStore) => ({
			updateState: function (patches: Parameters<typeof patchState>[1], action: string) {
				patchStateWithAction(store, patches, action);
			},
		})),
	);
}

// export function withUpdateState(): SignalStoreFeature<SignalStoreFeatureResult, WithUpdateStateOutput> {
// 	return signalStoreFeature(
// 		withMethods((store: InnerSignalStore) => ({
// 			updateState: function (patches: DeepPartial<SignalStoreFeatureResult['state']>, action: string) {
// 				patchStateWithAction(store, patches, action);
// 			},
// 		})),
// 	);
// }
